export default __webpack_public_path__ + "static/media/sr-success-1.e6928ac8.wav";